import React, {useState, useEffect} from "react";

import {Grid, Typography} from "@mui/material";
import { CompTextFieldNew } from "../../../../../components/newComponents/TextField";
import { CompInputListNew } from "../../../../../components/newComponents/InputListNew";
import {connect} from "react-redux";
import {
    getYouthCardInfo,
    listFunctionTemplates,
    setFunction,
} from "../../../function.actions";
import {CompPartitionHeader} from "../../../../../components/PartitionHeader";
import {
    encase
} from "../../../components/functionFormComponentUtils";
import {useTranslation} from "react-i18next";
import {listLocations} from "../../../../location/location.actions";
import {
    getOrganizationTree,
    listMunicipalityUsersSilent,
    listOrganizations
} from "../../../../municipality/municipality.actions";
import {updateContentIdentifierChoices} from "../../../../root/root.actions";
import { ButtonPrimary } from "../../../../../components/newComponents/ButtonPrimary";
import CircularProgress from "@mui/material/CircularProgress";

const FunctionParticipantsAndFeedbackComponent = (props) => {
    const {
        handleChange,
        func,
        sectionHasError,
        editorActivated,
        action,
        selectedFunction,
        fieldErrors = {},
        municipalities
    } = props;
    const {t} = useTranslation('translation');

    const disableAll = !editorActivated || action === "share";

    const [temporary, setTemporary] = useState(false);
    const [loading, setLoading] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [youthDataList, setYouthDataList] = useState(null);

    const showParticipantInformation = true;

    const rep = func.feedbackReport && func.feedbackReport.eventId === selectedFunction.id;
    const r = func.feedbackReport ? func.feedbackReport : {};

    useEffect(() => {
        setYouthDataList(func.youthData)
    }, [func.youthData, setYouthDataList])

    useEffect(() => {
        if (temporary) {
            setTemporary(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [temporary])

    const isYouthData = youthDataList && Object.values(youthDataList).every(v => v === 0);

    const takeFromFeedbackValues = () => {
        if (func.feedbackReport) {
            selectedFunction.participantsMen = func.feedbackReport.participantsMenAnswered;
            selectedFunction.participantsWomen = func.feedbackReport.participantsWomenAnswered;
            selectedFunction.participantsOther = func.feedbackReport.participantsOtherAnswered;
            selectedFunction.participantsSexNotAnswered	= func.feedbackReport.participantsSexNotAnsweredAnswered;
            selectedFunction.participants = selectedFunction.participantsMen + selectedFunction.participantsWomen + selectedFunction.participantsOther + selectedFunction.participantsSexNotAnswered;

            selectedFunction.participantsAge_1To_8 = func.feedbackReport.participantsAge1to8Answered;
            selectedFunction.participantsAge_9To_12 = func.feedbackReport.participantsAge9to12Answered;
            selectedFunction.participantsAge_13To_15 = func.feedbackReport.participantsAge13to15Answered;
            selectedFunction.participantsAge_16To_17 = func.feedbackReport.participantsAge16to17Answered;
            selectedFunction.participantsAge_18To_28 = func.feedbackReport.participantsAge18to28Answered;
            selectedFunction.participantsAge_18To_20 = func.feedbackReport.participantsAge18to20Answered;
            selectedFunction.participantsAge_21To_24 = func.feedbackReport.participantsAge21to24Answered;
            selectedFunction.participantsAge_25To_28 = func.feedbackReport.participantsAge25to28Answered;
            selectedFunction.participantsAge_29OrMore = func.feedbackReport.participantsAge29orMoreAnswered;
            selectedFunction.participantsAgeNotAnswered = func.feedbackReport.participantsAgeNotAnsweredAnswered
            setTemporary(true);
        }
    }

    const ncheck = (somevalue) => {
        if (somevalue === null || somevalue === undefined || somevalue < 0) return 0;
        return parseInt(somevalue);
    }

    const getDataFromYouthCard = () => {
        var id = selectedFunction.id
        props.getYouthCardInfo(id)

        if (youthDataList) {
            selectedFunction.participantsAge_29OrMore = ncheck(selectedFunction.participantsAge_29OrMore) + ncheck(youthDataList.age29orMore);
            selectedFunction.participants = ncheck(selectedFunction.participants) + ncheck(youthDataList.participants);
            selectedFunction.participantsWomen = ncheck(selectedFunction.participantsWomen) + ncheck(youthDataList.women);
            selectedFunction.participantsMen = ncheck(selectedFunction.participantsMen) + ncheck(youthDataList.men);
            selectedFunction.participantsOther = ncheck(selectedFunction.participantsOther) + ncheck(youthDataList.other);
            selectedFunction.participantsSexNotAnswered	= (selectedFunction.participantsSexNotAnswered ? selectedFunction.participantsSexNotAnswered : 0 ) + ncheck(youthDataList.sexNotAnswered);
            selectedFunction.participantsAge_1To_8 = ncheck(selectedFunction.participantsAge_1To_8) + ncheck(youthDataList.age1to8);
            selectedFunction.participantsAge_9To_12 = ncheck(selectedFunction.participantsAge_9To_12) + ncheck(youthDataList.age9to12);
            selectedFunction.participantsAge_13To_15 = ncheck(selectedFunction.participantsAge_13To_15) + ncheck(youthDataList.age13to15);
            selectedFunction.participantsAge_16To_17 = ncheck(selectedFunction.participantsAge_16To_17) + ncheck(youthDataList.age16to17);
            selectedFunction.participantsAge_18To_28 = ncheck(selectedFunction.participantsAge_18To_28) + ncheck(youthDataList.age18to28);
            selectedFunction.participantsAge_18To_20 = ncheck(selectedFunction.participantsAge_18To_20) + ncheck(youthDataList.age18to20);
            selectedFunction.participantsAge_21To_24 = ncheck(selectedFunction.participantsAge_21To_24) + ncheck(youthDataList.age21to24);
            selectedFunction.participantsAge_25To_28 = ncheck(selectedFunction.participantsAge_25To_28) + ncheck(youthDataList.age25to28);
            selectedFunction.participantsAgeNotAnswered = (selectedFunction.participantsAgeNotAnswered ? selectedFunction.participantsAgeNotAnswered : 0) + ncheck(youthDataList.ageNotAnswered);
            setTemporary(true);
            setLoading(true)
            setDisabled(true)

            setTimeout(() => {
                setLoading(false)
            }, 400)
        }
    };

    const handleNonNegativeChange = (event) => {
        if (event.target.value < 0) {
            event.target.value = 0;
        }

        handleChange(event);
    };

    const participantsSexRows = [
        {value: selectedFunction.participantsMen, key: "participantsMen", label: `${t('function.men') + encase(rep, r.participantsMenAnswered)}`},
        {value: selectedFunction.participantsWomen, key: "participantsWomen", label: `${t('function.women') + encase(rep, r.participantsWomenAnswered)}`},
        {value: selectedFunction.participantsOther, key: "participantsOther", label: `${t('function.other') + encase(rep, r.participantsOtherAnswered)}`},
        {value: (row, rows, total, expectedTotal) => expectedTotal == null ? 0 : expectedTotal - total, key: "participantsSexNotAnswered", label: `${t('function.not_answered') + encase(rep, r.participantsSexNotAnsweredAnswered)}` },
    ];

    const participantsAgeRows = [
        {value: selectedFunction.participantsAge_1To_8, key: "participantsAge_1To_8", label: `${t('function.age_1_to_8') + encase(rep, r.participantsAge1to8Answered)}`},
        {value: selectedFunction.participantsAge_9To_12, key: "participantsAge_9To_12", label: `${t('function.age_9_to_12') + encase(rep, r.participantsAge9to12Answered)}`},
        {value: selectedFunction.participantsAge_13To_15, key: "participantsAge_13To_15", label: `${t('function.age_13_to_15') + encase(rep, r.participantsAge13to15Answered)}`},
        {value: selectedFunction.participantsAge_16To_17, key: "participantsAge_16To_17", label: `${t('function.age_16_to_17') + encase(rep, r.participantsAge16to17Answered)}`},
        {value: selectedFunction.participantsAge_18To_28, key: "participantsAge_18To_28", label: `${t('function.age_18_to_28') + encase(rep, r.participantsAge18to28Answered)}`},
        {value: selectedFunction.participantsAge_29OrMore, key: "participantsAge_29OrMore", label: `${t('function.age_29_or_more') + encase(rep, r.participantsAge29orMoreAnswered)}`},
        {value: (row, rows, total, expectedTotal) => expectedTotal == null ? 0 : expectedTotal - total, key: "participantsAgeNotAnswered", label: `${t('function.unknown') + encase(rep, r.participantsAgeNotAnsweredAnswered)}`},
    ]

    const participantsAgeRowsNew = [
        {value: selectedFunction.participantsAge_1To_8, key: "participantsAge_1To_8", label: `${t('function.age_1_to_8') + encase(rep, r.participantsAge1to8Answered)}`},
        {value: selectedFunction.participantsAge_9To_12, key: "participantsAge_9To_12", label: `${t('function.age_9_to_12') + encase(rep, r.participantsAge9to12Answered)}`},
        {value: selectedFunction.participantsAge_13To_15, key: "participantsAge_13To_15", label: `${t('function.age_13_to_15') + encase(rep, r.participantsAge13to15Answered)}`},
        {value: selectedFunction.participantsAge_16To_17, key: "participantsAge_16To_17", label: `${t('function.age_16_to_17') + encase(rep, r.participantsAge16to17Answered)}`},
        {value: selectedFunction.participantsAge_18To_20, key: "participantsAge_18To_20", label: `${t('function.age_18_to_20') + encase(rep, r.participantsAge18to20Answered)}`},
        {value: selectedFunction.participantsAge_21To_24, key: "participantsAge_21To_24", label: `${t('function.age_21_to_24') + encase(rep, r.participantsAge21to24Answered)}`},
        {value: selectedFunction.participantsAge_25To_28, key: "participantsAge_25To_28", label: `${t('function.age_25_to_28') + encase(rep, r.participantsAge25to28Answered)}`},
        {value: selectedFunction.participantsAge_29OrMore, key: "participantsAge_29OrMore", label: `${t('function.age_29_or_more') + encase(rep, r.participantsAge29orMoreAnswered)}`},
        {value: (row, rows, total, expectedTotal) => expectedTotal == null ? 0 : expectedTotal - total, key: "participantsAgeNotAnswered", label: `${t('function.unknown') + encase(rep, r.participantsAgeNotAnsweredAnswered)}`},
    ]

    var useNewAge = false;

    municipalities.forEach((m) => {
        if (m.id === selectedFunction.municipalityId && m.useNewAge) {
            useNewAge = true;
        }
    })

    return (
        <>
            <Grid className={'MuiGrid-item function_part-feedback-comp'} size={12} error={sectionHasError([
                            'participants',
                            'youthOrganizers',
                            'eventHoursOfYouthOrganizers',
                            'description',
                            "participantsAge",
                            "participantsSex"
                        ]) ? t('errors.has error') : null}>
                    <CompPartitionHeader text={t("function.participants_and_feedback")}/>
                    <Typography className={'modalDescription participants_feedback_desc'} tabIndex={0}>
                        {t("function.participants_description")}
                    </Typography>
                <Grid container className={"participants_comp-wrapper"} spacing={0} sx={{padding: "0 !important"}} >
                    <Grid  size={{xs: 12, sm: 6}}>
                        <CompTextFieldNew
                            label={t('function.participants')}
                            value={selectedFunction.participants}
                            disabled={disableAll}
                            isLabelShrink={true}
                            name="participants"
                            type="number"
                            error={fieldErrors.participants}
                            onChange={handleNonNegativeChange}
                        />
                        <CompTextFieldNew
                            label={t('function.youth_organizers')}
                            value={selectedFunction.youthOrganizers}
                            disabled={disableAll}
                            isLabelShrink={true}
                            name="youthOrganizers"
                            type={'number'}
                            error={fieldErrors.youthOrganizers}
                            onChange={handleNonNegativeChange}
                        />
                        <CompTextFieldNew
                            label={t('function.event_hours_of_youth_organizers')}
                            value={selectedFunction.eventHoursOfYouthOrganizers}
                            isLabelShrink={true}
                            disabled={disableAll}
                            name="eventHoursOfYouthOrganizers"
                            type={'number'}
                            error={fieldErrors.eventHoursOfYouthOrganizers}
                            onChange={handleNonNegativeChange}
                        />
                        <Grid className={"MuiGrid-item function_participants_info-comp"} size={{xs: 12, sm: 12}}>
                            {(!temporary && showParticipantInformation && ((rep || !selectedFunction.id) || !selectedFunction.feedbackGenderAndAge)) && (
                                <Grid className={"MuiGrid-item participants_age-comp"} size={{xs: 12, sm: 12}}>
                                    <CompInputListNew
                                        label={t('function.participants_pieces')}
                                        name="participantsSex"
                                        rows={participantsSexRows}
                                        disabled={disableAll}
                                        expectedTotal={selectedFunction.participants}
                                        error={fieldErrors.participantsSex}
                                        onChange={handleChange}
                                    />
                                </Grid>)}
                        </Grid>
                    </Grid>
                    <Grid className={"MuiGrid-item function_participants_info-comp"} size={{xs: 12, sm: 6}}>
                        {(!temporary && showParticipantInformation && ((rep || !selectedFunction.id) || !selectedFunction.feedbackGenderAndAge)) &&
                            (<Grid size={{xs: 12, sm: 12}} className={"MuiGrid-item participants_sex-comp"}>
                                {
                                    (useNewAge && selectedFunction.useNewAge !== false) || selectedFunction.useNewAge ?
                                        <CompInputListNew
                                            label={t('function.participants_age_info')}
                                            name="participantsAge"
                                            rows={participantsAgeRowsNew}
                                            disabled={disableAll}
                                            expectedTotal={selectedFunction.participants}
                                            error={fieldErrors.participantsAge}
                                            onChange={handleChange}/> :
                                        <CompInputListNew
                                            label={t('function.participants_age_info')}
                                            name="participantsAge"
                                            rows={participantsAgeRows}
                                            disabled={disableAll}
                                            expectedTotal={selectedFunction.participants}
                                            error={fieldErrors.participantsAge}
                                            onChange={handleChange}/>
                                }
                                
                            </Grid>)}
                        {rep && editorActivated && (
                            <Grid className={"MuiGrid-item"} size={{xs: 12, sm: 12}}>
                                <ButtonPrimary
                                    key={'load_csv'}
                                    onClick={e => takeFromFeedbackValues(e)}>
                                    {t('function.use_feedback_values')}
                                </ButtonPrimary>
                            </Grid>)}
                        {editorActivated && selectedFunction.id && !isYouthData &&
                            <ButtonPrimary
                                disabled={disabled}
                                onClick={e => getDataFromYouthCard()}>
                                {loading ? `${t('function.loading')}` : `${t('function.loadYouthData')}`}
                            </ButtonPrimary>}
                        {loading && <CircularProgress className="loader" />}
                    </Grid>
                </Grid>
            </Grid>
        </>
    );
}

const mapStateToProps = (state) => {
    return {
        municipalities: state.municipality.municipalities,
        func: state.func,
        templates: state.func.templates,
        authenticatedUser: state.auth.authenticatedUser,
        selectedFunction: state.func.selectedFunction,
        organizationTree: state.municipality.organizationTree,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setFunction: (data) => dispatch(setFunction(data)),
        listFunctionTemplates: (municipalityId) => dispatch(listFunctionTemplates(municipalityId)),
        listLocations: (municipalityId) => dispatch(listLocations(municipalityId)),
        listOrganizations: (municipalityId) => dispatch(listOrganizations(municipalityId)),
        getOrganizationTree: (municipalityId, level) => dispatch(getOrganizationTree(municipalityId, level)),
        listMunicipalityUsersSilent: (municipalityId) => dispatch(listMunicipalityUsersSilent(municipalityId)),
        updateContentIdentifierChoices: (municipalityId) => dispatch(updateContentIdentifierChoices(municipalityId)),
        getYouthCardInfo: (eventId, onSuccess) => dispatch(getYouthCardInfo(eventId, onSuccess)),
    };
}

export const FunctionParticipantsAndFeedbackComp = connect(
    mapStateToProps,
    mapDispatchToProps)
(FunctionParticipantsAndFeedbackComponent);
